export interface PipRunName {
  id: string;
  name: string;
  defaultPresetId?: string;
}

export enum PipRunNameEnum {
  CellTyping = 'cell_typing',
  GenericPipsRun = 'generic_pips_run',
  NeighborhoodClusters = 'neighborhood_clusters',
}
